import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp, useSession, useTheme } from "contexts";
import { Routes } from "utils";

export const useNavigationAction = (onCloseCallback?: () => void) => {
  const navigate = useNavigate();

  const { t } = useApp();
  const { theme, toggleTheme } = useTheme();
  const { isAuthenticated, logout, user } = useSession();

  const [opened, setOpened] = useState<boolean>(false);

  const closeSidebar = () => setOpened(false);
  const openSidebar = () => setOpened(true);

  const handleNew = () => {
    onCloseCallback?.();
    navigate(Routes.createnew);
  };

  const handleLogin = () => {
    onCloseCallback?.();
    navigate(Routes.auth);
  };

  const handleProfile = () => {
    onCloseCallback?.();
    navigate(Routes.userdashboard);
  };

  const handleLogout = () => {
    onCloseCallback?.();
    logout();
    navigate(Routes.home);
  };

  const handleTheme = () => toggleTheme();

  return {
    t,
    theme,
    isAuthenticated,
    user,
    opened,
    openSidebar,
    closeSidebar,
    handleNew,
    handleLogin,
    handleProfile,
    handleLogout,
    handleTheme,
  };
};
